import React, { Component } from 'react'
import { Grid } from 'semantic-ui-react'
import GreetingTemplate from '../../components/GreetingTemplate'

export default class Thank extends Component {
  render() {
    return (
      <Grid centered>
        <Grid.Column mobile={14} tablet={10} computer={10}>
          <GreetingTemplate />
        </Grid.Column>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/conteiners/Greeting/index.js